export default "__VITE_ASSET__DcJqgSM2__"